import {mergeProperties, reverseEnum} from "../components/Utility";
import {OrderStatus, PaymentStatus} from "../enums/enums";
import moment from "moment-timezone";

const timezone = 'Asia/Kolkata';
export const getFormData = (data) => {
    const initialData = {
        _id: '',
        paymentType: '',
        paymentStatus: '',
        orderStatus: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};


export const getTableColumns = () => {
    let tableColumns = [
        {header: "Name", field: "name"},
        {header: "Quantity", field: "quantity"},
        {header: "Price", field: "price"},
    ];
    return tableColumns;
};

export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        name: item.name,
        quantity: item.quantity,
        price: item.sellPrice,
    }));
};

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            Id: item.id,
            orderNo: item.orderNo,
            Name: item?.createdBy.fName,
            Phone: item?.createdBy.phone,
            orderStatus: reverseEnum(OrderStatus)[item.orderStatus],
            paymentStatus: reverseEnum(PaymentStatus)[item.paymentStatus],
            paymentType: item.paymentType,
            orderTime: moment(item.orderTime).tz(timezone).format('ddd, MMM DD, YYYY, hh:mm A'),
            serviceType: item.serviceType,
            discount: item.discountAmount,
            toPay: item.totalPrice,
        },
    };
};